var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"author-wrapper position-relative"},[_vm._v(" 创作者专题页 "),_c('div',{staticClass:"position-absolute w-100 p-4 bottom-0"},[_c('el-button',{staticClass:"w-100",attrs:{"type":"primary","round":""},on:{"click":_vm.goApply}},[_vm._v("立即报名")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }